import { useEffect } from "react"

export const useDialogEscapeClose = (show: boolean, onCancel: () => void): void => {
    useEffect(() => {
        if (!show) {
            return
        }

        const closeOnEscape = (event: KeyboardEvent): void => {
            if (event.key !== "Escape") {
                return
            }

            event.preventDefault()
            event.stopPropagation()
            event.stopImmediatePropagation()
            onCancel()
        }

        document.addEventListener("keydown", closeOnEscape, { capture: true })
        return (): void => document.removeEventListener("keydown", closeOnEscape, { capture: true })
    }, [onCancel, show])
}
